"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import "../AutoVerkaufen.css";
import "@/common/Common.css";

import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { TopSectionAutoVerkaufen } from "../sections/TopSection";
import { AutoVerkaufenGrid } from "../../../common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";
import { fragenAutoExport } from "./data";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";

import BannerImage1 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig1.avif";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";

// Only needed after step 11; keep auth-related code/CSS out of initial paint.
// Below-the-fold section; defer to reduce initial route JS/CSS.
const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AutoExport() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionAutoVerkaufen
        title={
          <>
            Auto export leicht gemacht – <br />
            Schnell, sicher und profitabel!
          </>
        }
        text={
          <>
            Autoeinfachlos macht Autoexport einfach:
            <br />
            kostenlos, sicher und mit schneller Bezahlung – <br /> inklusive
            Abholung direkt bei dir!
          </>
        }
        linkname="Auto Export"
        link="/auto-verkaufen/auto-export"
        customNav="Auto verkaufen"
        customNavLink="/auto-verkaufen"
        className="auto-export-main-wrapper"
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen/auto-export"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color AV-below-fold">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Gründe, um dein Fahrzeug an Auto Export zu verkaufen"
              leftText={
                <>
                  <p>
                    Ein Auto für den Export zu verkaufen, kann viele Gründe
                    haben. Ob dein Fahrzeug auf dem heimischen Markt nicht mehr
                    gefragt ist oder internationale Käufer bereit sind, bessere
                    Preise zu zahlen – der Export bietet attraktive
                    Möglichkeiten. Hier sind einige typische Szenarien:
                  </p>

                  <ul className="custom-unordered-list secondary">
                    <li>
                      Das Fahrzeug entspricht nicht mehr den technischen
                      Anforderungen in Österreich (z.B. Emissionsvorgaben oder
                      Sicherheitsstandards).
                    </li>
                    <li>
                      Die Zahlungsbereitschaft ausländischer Autokäufer ist
                      häufig höher.
                    </li>
                    <li>
                      Reparaturen oder Anpassungen wären in Österreich zu
                      kostspielig.
                    </li>
                    <li>
                      Im Ausland besteht eine höhere Nachfrage nach bestimmten
                      Fahrzeugmodellen.
                    </li>
                    <li>
                      Der Verkauf in Österreich gestaltet sich schwierig
                      aufgrund von Überangebot oder spezifischen Anforderungen.
                    </li>
                    <li>
                      Im Ausland gelten weniger strenge Regelungen für ältere
                      oder defekte Fahrzeuge.
                    </li>
                  </ul>
                  <p>
                    Mit Autoeinfachlos wird der gesamte Prozess einfach,
                    stressfrei und sicher gestaltet.
                  </p>
                </>
              }
              rightFirstTitle="So funktioniert der Autoexport mit Autoeinfachlos!"
              rightFirstText={
                <>
                  <p>
                    Mit Autoeinfachlos wird der Autoexport so einfach wie nie
                    zuvor. Wir arbeiten mit zuverlässigen Export-Partnern
                    zusammen, die jedes Fahrzeug abnehmen – unabhängig von
                    Schäden oder Defekten. Selbst nicht fahrbereite Autos können
                    problemlos exportiert werden. Deine Vorteile beim Auto
                    export verkaufen mit uns:
                  </p>

                  <p>Deine Vorteile:</p>

                  <ul className="custom-unordered-list ">
                    <li>Kostenlose Abholung direkt bei dir zuhause.</li>
                    <li>
                      Schnelle Überweisung des Verkaufspreises auf dein Konto.
                    </li>
                    <li>Schneller Verkauf in weniger als 48 Stunden.</li>
                    <li>
                      Du erledigst alles bequem von zuhause – ohne Aufwand.
                    </li>
                    <li>
                      Einfache und unkomplizierte Abwicklung, ganz ohne Stress.
                    </li>
                    <li>Bestpreis garantiert für dein Fahrzeug.</li>
                  </ul>
                </>
              }
              rightSecondTitle="Welche Autos eignen sich für den Export?"
              rightSecondText={
                <>
                  <p>
                    Autos, deren Reparatur- oder Wiederbeschaffungskosten in
                    Österreich nicht mehr wirtschaftlich sind, eignen sich
                    hervorragend für den Auto Export.
                  </p>
                  <p>Geeignete Fahrzeuge für den Auto Export:</p>

                  <ul className="custom-unordered-list secondary">
                    <li>Alle Marken</li>
                    <li>Alle Modelle</li>
                    <li>Baujahr liegt mehr als 10 Jahre zurück</li>
                    <li>Über 200.000 Kilometerlaufleistung</li>
                  </ul>
                </>
              }
            />
            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage1}
                revert
                isBig
                h2
                alt="Auto Export Banner Preis"
                title="Risiken beim Autoexport – Was du wissen solltest"
                text={
                  <>
                    <p>
                      Beim Auto an Export verkaufen können verschiedene Risiken
                      auftreten, die dich Zeit und Geld kosten können.
                      Unsicherheiten bei Zahlungen, falsch ausgefüllte Dokumente
                      oder überhöhte Exportkosten sind nur einige der Gefahren,
                      die beim Autoverkauf ins Ausland entstehen können. Ohne
                      einen erfahrenen Partner läufst du Gefahr, dein Fahrzeug
                      unter Wert zu verkaufen oder gar Verluste zu erleiden.
                    </p>

                    <p>
                      <strong>Risiken:</strong>
                    </p>
                    <ul>
                      <li>
                        Falsche oder unvollständige Dokumente können zusätzliche
                        Gebühren verursachen.
                      </li>
                      <li>
                        Exportkosten können die Einnahmen aus dem Verkauf
                        übersteigen.
                      </li>
                      <li>
                        Zahlungsverzug oder fehlende Überweisung bei
                        Vorablieferung des Autos.
                      </li>
                      <li>
                        Risiko, das Fahrzeug weit unter Marktwert zu verkaufen.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage2}
                isBig
                title="Privater Autoexport"
                h2
                alt="Privater Autoexport vs Export mit einem Profi"
                text={
                  <>
                    <p>
                      Ein Auto privat ins Ausland zu verkaufen, kann aufwendig
                      und riskant sein. Im Vergleich dazu bietet ein
                      professioneller Export-Service zahlreiche Vorteile.
                    </p>
                    <p>
                      <strong>Privater Autoexport:</strong>
                    </p>

                    <ul>
                      <li>
                        Hoher Aufwand: Du musst den gesamten Verkaufsprozess
                        selbst organisieren, von der Käufersuche bis zur
                        Zollabwicklung.
                      </li>
                      <li>
                        Risiken bei Zahlungen: Es gibt keine Garantie, dass du
                        dein Geld sicher und rechtzeitig erhältst.
                      </li>
                      <li>
                        Kostenfalle: Exportgebühren und Logistikkosten können
                        den Verkaufserlös übersteigen.
                      </li>
                      <li>
                        Unübersichtliche Prozesse: Falsch ausgefüllte Dokumente
                        können teure Verzögerungen verursachen.
                      </li>
                    </ul>

                    <p>
                      Mit einem erfahrenen Service wie Autoeinfachlos minimierst
                      du diese Risiken und profitierst von einer sicheren,
                      unkomplizierten Abwicklung.
                    </p>
                  </>
                }
              />
              <BildTextInfo
                image={BannerImage3}
                title="Warum Autoeinfachlos die beste Wahl für Autoexport ist"
                alt="Auteinfachlos beste wahl für den export"
                isBig
                h2
                revert
                text={
                  <>
                    <p>
                      Überlasse den Autoexport nicht dem Zufall – mit
                      Autoeinfachlos erhältst du einen umfassenden Service, der
                      einfach, schnell und profitabel ist. Egal ob dein Auto aus
                      dem Baujahr 1999, 2009 oder 2017 stammt, wir nehmen jedes
                      Fahrzeug und ermitteln kostenlos den besten Verkaufspreis
                      für dich.
                    </p>
                    <p>
                      Kein Papierkram, keine komplizierten Zollbestimmungen –
                      wir machen den Prozess für dich so unkompliziert wie
                      möglich. Innerhalb weniger Minuten bekommst du online den
                      aktuellen Marktwert deines Autos. Anschließend bieten über
                      5.000 Händler auf dein Fahrzeug, sodass du sicher den
                      besten Preis erzielst.
                    </p>

                    <p>
                      Das Beste: Du musst nicht einmal dein Haus verlassen. Wir
                      holen dein Auto kostenlos bei dir ab und sorgen für eine
                      schnelle, sichere Bezahlung. Mit Autoeinfachlos ist der
                      Autoexport einfach wie nie zuvor!
                    </p>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufig gestellte Fragen zum Auto Export "
              fragen={fragenAutoExport}
              image={FAQImage}
            />
            <Ratgeber
              title="Mehr zum Thema Auto Export"
              autoVerkaufen
              autoBewerten
              kaputtesAuto
              autoMitMotorschaden
              unfallAuto
              notVerkauf
            />
          </div>
          <Banner />
        </div>
      )}
    </div>
  );
}

export default AutoExport;
